export default __webpack_public_path__ + "static/media/subtraction.db617830.svg";